const hostname = window.location.hostname

export const maxDiagnosisCodes = 2;
export const maxCompoundIngredientComponentCount = 25;

const oktaConfig = {
  baseUrl: '',
  clientId: '',
  portalId: '',
  end: ''
}

const hostURLs = {
  dev: 'california.smartrx-dev.lh.primetherapeutics.com',
  test: 'california.smartrx-test.lh.primetherapeutics.com',
  mhqa: 'qa.magellanrx.com',
  mhtest: 'test.magellanrx.com',
  mhprod: 'magellanrx.com'
}

if (
  hostname === 'localhost' ||
  hostname.indexOf(hostURLs.mhqa) !== -1 ||
  hostname.indexOf(hostURLs.mhtest) !== -1 ||
  hostname.indexOf(hostURLs.dev) !== -1 ||
  hostname.indexOf(hostURLs.test) !== -1
) {
  // QA Config
  oktaConfig.baseUrl = 'https://ciam-dev.primetherapeutics.com'
  oktaConfig.clientId = '0oa8xfyrk6gc773On1d7'
  oktaConfig.portalId = '0oaczm2ingrvdEZIJ1d7'
  oktaConfig.end = 'aln177a159h7Zf52X0g8'

} else if (hostname.indexOf(hostURLs.mhprod) !== -1) {
  // PROD Config
  oktaConfig.baseUrl = 'https://ciam.primetherapeutics.com'
  oktaConfig.clientId = '0oa4v6j66q671BQxA4h7'
  oktaConfig.portalId = '0oa7nh0yii5HtWJta4h7'
  oktaConfig.end = 'aln177a159h7Zf52X0g8'
} else {
  // If we don't find any properly defined QA and PROD Config, use the following
  oktaConfig.baseUrl = 'https://ciam-dev.primetherapeutics.com'
  oktaConfig.clientId = '0oa8xfyrk6gc773On1d7'
  oktaConfig.portalId = '0oaczm2ingrvdEZIJ1d7'
  oktaConfig.end = 'aln177a159h7Zf52X0g8'
}

const oktaEnv = {
  ENV: { url: oktaConfig.baseUrl, id: oktaConfig.clientId }
}

const CONST_URL = {
  OKTA_ENV: oktaEnv.ENV,
  OKTA_DOMAIN: oktaConfig.baseUrl,
  OKTA_BASE: oktaConfig.baseUrl + '/',
  OKTA_AUTHORIZE: '/admin/authorize',
  OKTA_OAUTH_AUTHORIZE: '/oauth2/default/v1/authorize',
  OKTA_ADMIN_PORTAL_CLIENT_ID: oktaConfig.clientId,
  OKTA_PORTAL_CLIENT_ID: oktaConfig.portalId,
  OKTA_PORTAL_EMBED_LINK:
    oktaConfig.baseUrl +
    '/home/oidc_client/' +
    oktaConfig.portalId +
    '/' +
    oktaConfig.end,
  MICRO_BASE: '/portalmicroservices',
  OAUTH_LOGIN: '/oauthproxy/oauth/token/genericnonsso',
  OAUTH_LOGOUT: '/oauthproxy/oauth/logout',
  PORTAL_BASE: '/portalmicroservices/api',
  PORTAL_BASE_UNSECURE: '/portalmicroservices',
  TRANSLATIONS_BASE: '/portalmicroservices/public/translation',
  CORE_PORTAL_ADMIN: '/portaladminws-ext/api'
}

export default CONST_URL
